import axios, { AxiosError, AxiosResponse } from 'axios';
import { RESPONSE_CODE } from '@/constants/ApiConstants';

interface SavePushNotificationTokenRequest {
  registrationToken: string;
  topics: string[];
}

interface DeletePushNotificationTokenRequest {
  registrationTokens: string[];
}

interface PushNotificationApiResponse {
  code: number;
}

interface PushNotificationApiErrorResponse {
  code: number;
  message?: string;
  data?: unknown;
}

const PUSH_ENDPOINT: string = 'api/push/token';

const handleApiError = (error: unknown, ignoredErrorCode: number, operationName: string): void => {
  const apiError = error as AxiosError<PushNotificationApiErrorResponse>;

  if (apiError.response?.data?.code === ignoredErrorCode) {
    return;
  }

  console.error(`Failed to ${operationName}:`, error);
  const errorMessage = apiError.response?.data?.message || apiError.message || 'Unknown error';
  throw new Error(`Failed to ${operationName}: ${errorMessage}`);
};

const savePushNotificationTokenToDatabase = async (
  firebaseMessagingToken: string,
): Promise<void> => {
  try {
    const requestPayload: SavePushNotificationTokenRequest = {
      registrationToken: firebaseMessagingToken,
      topics: ['ordering statuses'],
    };

    const response: AxiosResponse<PushNotificationApiResponse> = await axios.post(
      PUSH_ENDPOINT,
      requestPayload,
    );

    console.debug('Save push notification token response:', response);
  } catch (error) {
    handleApiError(
      error,
      RESPONSE_CODE.CODE_DUPLICATE_PUSH_NOTIFICATION_TOKEN,
      'save push notification token to database',
    );
  }
};

const deletePushNotificationTokenFromDatabase = async (
  firebaseMessagingToken: string,
): Promise<void> => {
  try {
    const requestPayload: DeletePushNotificationTokenRequest = {
      registrationTokens: [firebaseMessagingToken],
    };

    const response: AxiosResponse<PushNotificationApiResponse> = await axios.delete(PUSH_ENDPOINT, {
      data: requestPayload,
    });

    console.debug('Delete push notification token response:', response);
  } catch (error) {
    handleApiError(
      error,
      RESPONSE_CODE.CODE_PUSH_NOTIFICATION_TOKEN_NOT_FOUND,
      'delete push notification token from database',
    );
  }
};

export default {
  savePushNotificationTokenToDatabase,
  deletePushNotificationTokenFromDatabase,
};
